<template>
	<BaseButton
		:classes="computedClass"
		:label="label"
		:size="size"
		:disabled="isDisabled"
		:type="type"
		@click="$emit('click')"
	/>
</template>
<script>
import BaseButton from '@/components/shared/Button/BaseButton/BaseButton.vue';

export default {
	name: 'ButtonPrimary',
	components: {
		BaseButton,
	},
	props: {
		label: {
			type: String,
			required: true,
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: 'md',
		},
		type: {
			type: String,
			default: 'button',
		},
	},
	computed: {
		computedClass() {
			return ['button__primary'];
		},
	},
};
</script>
<style lang="scss" scoped>
@import './ButtonPrimary.scss';
</style>
